export default "__VITE_ASSET__UoaIw14n__"